import { render, staticRenderFns } from "./manage-groups-table.vue?vue&type=template&id=fa913cca&scoped=true&"
import script from "./manage-groups-table.vue?vue&type=script&lang=js&"
export * from "./manage-groups-table.vue?vue&type=script&lang=js&"
import style0 from "./manage-groups-table.vue?vue&type=style&index=0&id=fa913cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa913cca",
  null
  
)

component.options.__file = "manage-groups-table.vue"
export default component.exports